const Loading: React.FC = () => (
  <h1
    style={{
      fontFamily: 'Montserrat',
      margin: '30px auto',
      textAlign: 'center',
      color: '#2253F5',
      fontSize:'1.5rem'
    }}
  >
    Carregando
  </h1>
);

export default Loading;
